import { createStore } from 'owa-satcheljs';
import type ComposeFormOptionStore from './schema/ComposeFormOptionStore';

const defaultExport: () => ComposeFormOptionStore = createStore<ComposeFormOptionStore>(
    'composeFormInPopOutOption',
    {
        composeFormOptionState: null,
    }
);
export default defaultExport;
